import { Component, OnInit } from '@angular/core';
import { CustomSelectComponent } from '../../Core/custom-select/custom-select.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { FirmService } from '../../../Services/firm.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserCustomerService } from '../../../Services/User/Customer/user-customer.service';
import { NotificationService } from '../../../Services/notification.service';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { Country } from '../../../Models/country';
import { UserServiceService } from '../../../Services/user.service';
import { Cities } from '../../../Models/Cities';
import { States } from '../../../Models/States';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import intlTelInput from 'intl-tel-input';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { AuthService } from '../../../Services/auth.service';


@Component({
  selector: 'app-sell-customer',
  imports: [CustomSelectComponent, NgFor, ReactiveFormsModule, NgIf, RouterLink,],
  templateUrl: './sell-customer.component.html',
  styleUrl: './sell-customer.component.css'
})
export class SellCustomerComponent implements OnInit, AfterViewInit {
  @ViewChild('phoneInput') phoneInput!: ElementRef;
  itiInstance: any;   // ✅ Store intl-tel-input instance
  prodCategory: string[] = ['Mr.', 'Mrs.', 'Ms.', 'M/S.'];
  customerTypes: string[] = ['Wholesale', 'Retailer', 'Direct Customer', 'Family', 'Friend'];
  selectedCustomer: string = '';
  selectedProdCategory: string = '';
  firmTypes: { id: number; name: string }[] = [];
  selectedFirmType: string = '';
  sellCustomerForm!: FormGroup;
  customerData: any;
  searchText: string = '';
  showDropdown = false;
  filteredCustomers: any[] = [];
  customerId: any;
  activeIndex = -1;
  nameSearch: string = '';
  mobileSearch: string = '';
  countries: Country[] = [];
  cities: Cities[] = [];
  states: States[] = [];
  generatedOtp: string | null = null;
  message: string = '';
  //remove the below variables if not needed
  isOtpSent = false;
  isOtpVerified = false;

  constructor(private firmService: FirmService, private fb: FormBuilder,
    private userCustomerService: UserCustomerService,
    private notificationService: NotificationService,
    @Inject(PLATFORM_ID) private platformId: object,   // ✅ THIS LINE FIXES THE ERROR
    private router: Router, private userService: UserServiceService,
    private authService:AuthService
  ) { }

  ngOnInit() {
    this.loadFirmList();
    this.initForm();
    this.getCustomerData();
    this.fetchCountries();
    this.filteredCustomers = [];
  }
  fetchCountries() {
    const params = new HttpParams();

    this.userService.getCountries(params).subscribe(
      (response: any) => {
        this.countries = response.data;
      },
      (error) => {
        console.error('Error fetching countries:', error);
        this.notificationService.showError(
          'Failed to fetch countries. Please try again.',
          'Error'
        );
      }
    );
  }

  initForm() {
    const firmId = localStorage.getItem('firm_id');

    this.sellCustomerForm = this.fb.group({
      user_title: [''],
      name: [''],
      user_last_name: [''],
      mobilenumber: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{6,15}$/)  // ✅ International safe
      ]],

      user_secondary_mobile_no: [''],
      user_aadhar_card_no: [''],
      user_pan_card_no: [''],
      user_firm_id: [firmId ? firmId : '', Validators.required],
      user_customer_type: [''],
      user_middle_name: [''],
      country_id: ['', [Validators.required]],
      city_id: ['', [Validators.required]],
      state_id: ['', [Validators.required]],
      gstnumber: [''],
      email: ['', [Validators.email]],
      pincode: [''],
      address: ['', [Validators.required]],
      otp: [''],

    })
  }

  onSubmit() {
  const nameControl = this.sellCustomerForm.get('name');
  const mobileControl = this.sellCustomerForm.get('mobilenumber');
  const typeControl = this.sellCustomerForm.get('user_customer_type');

  // ✅ 1. First Name Validation + Focus
  if (!nameControl || !nameControl.value || nameControl.invalid) {
    nameControl?.markAsTouched();

    this.notificationService.showError(
      'Please enter the first name',
      'Validation Error'
    );

    setTimeout(() => {
      const nameInput = document.getElementById('name') as HTMLInputElement | null;
      nameInput?.focus();
    });

    return;
  }

  // ✅ 2. Mobile Number Validation
  const selectedCountry = this.itiInstance?.getSelectedCountryData()?.iso2;
  const mobileValue = mobileControl?.value?.trim();

  if (!mobileControl || !mobileValue) {
    mobileControl?.markAsTouched();

    this.notificationService.showError(
      'Please enter the mobile number',
      'Validation Error'
    );

    setTimeout(() => {
      const input = document.getElementById('mobilenumber') as HTMLInputElement | null;
      input?.focus();
    });

    return;
  }

  // ✅ INDIA: Exactly 10 digits
  if (selectedCountry === 'in' && !/^[0-9]{10}$/.test(mobileValue)) {
    mobileControl?.markAsTouched();

    this.notificationService.showError(
      'Indian mobile number must be exactly 10 digits',
      'Validation Error'
    );

    setTimeout(() => {
      const input = document.getElementById('mobilenumber') as HTMLInputElement | null;
      input?.focus();
    });

    return;
  }

  // ✅ Other Countries: 6–15 digits
  if (selectedCountry !== 'in' && !/^[0-9]{6,15}$/.test(mobileValue)) {
    mobileControl?.markAsTouched();

    this.notificationService.showError(
      'Please enter a valid international mobile number',
      'Validation Error'
    );

    setTimeout(() => {
      const input = document.getElementById('mobilenumber') as HTMLInputElement | null;
      input?.focus();
    });

    return;
  }

  // ✅ 3. Customer Type Validation + Focus
  if (!typeControl || typeControl.invalid || !typeControl.value) {
    typeControl?.markAsTouched();

    this.notificationService.showError(
      'Please select the customer type',
      'Validation Error'
    );

    setTimeout(() => {
      const select = document.getElementById('user_customer_type') as HTMLSelectElement | null;
      select?.focus();
    });

    return;
  }

  // ✅✅✅ 4. BUILD FORMDATA (FIXED MOBILE STORAGE)
  const formData = new FormData();

  // ✅ Append all fields EXCEPT mobilenumber
  Object.keys(this.sellCustomerForm.value).forEach(key => {
    if (key !== 'mobilenumber') {
      formData.append(key, this.sellCustomerForm.value[key] ?? '');
    }
  });

  // ✅✅✅ APPEND FULL MOBILE WITH COUNTRY CODE (FINAL FIX)
  const countryData = this.itiInstance?.getSelectedCountryData();
  const dialCode = countryData?.dialCode ? `+${countryData.dialCode}` : '';
  const fullMobileNumber = dialCode + mobileValue;

  formData.append('mobilenumber', fullMobileNumber); // ✅ NOW STORES WITH COUNTRY CODE

  // ✅ If you re-enable file upload later
  // if (this.selectedFile) {
  //   formData.append('doc_user_img', this.selectedFile, this.selectedFile.name);
  // }

  // ✅ 5. Submit API
  this.userCustomerService.createUserCustomer(formData).subscribe({
    next: (res: any) => {
      this.customerId = res.data.id;

      this.notificationService.showSuccess(
        'Customer created successfully!',
        'Success'
      );

      this.router.navigate([
        `/sell-details-lot/${res.data.id}`
      ]);
    },
    error: (err: any) => {
      this.notificationService.showError('Error creating customer', 'Error');
      console.error('Error creating customer:', err);
    }
  });
}


  getCustomerData() {
    let params = new HttpParams();

    this.userCustomerService.getUserCustomers(params).subscribe((response: any) => {
      this.customerData = response.data;
    });
  }

  filterCustomers() {
    const name = this.nameSearch.trim().toLowerCase();
    const mobile = this.mobileSearch.trim();

    if (name || mobile) {
      this.filteredCustomers = this.customerData.filter((cust: any) => {
        const nameMatch = name ? cust.name?.toLowerCase().startsWith(name) : true;
        const mobileMatch = mobile ? cust.mobilenumber?.toString().startsWith(mobile) : true;

        // both must match if both have values
        return nameMatch && mobileMatch;
      }).slice(0, 5);
    } else {
      this.filteredCustomers = [];
    }
  }

  filterCustomersByName(event?: Event) {
    this.nameSearch = (event?.target as HTMLInputElement)?.value || '';
    this.filterCustomers();
  }

  filterCustomersByMobile(event?: Event) {
    this.mobileSearch = (event?.target as HTMLInputElement)?.value || '';
    this.filterCustomers();
  }

  selectCustomer(customer: any) {
    this.searchText = `${customer.name} ${customer.user_last_name || ''}`;
    this.showDropdown = false;
    this.onCustomerSelected(customer);
  }

  onCustomerSelected(customer: any) {
    this.customerId = customer.id;
    if (this.customerId && (customer.user_customer_type === 'Retailer' || customer.user_customer_type === 'Wholesale')) {
      this.router.navigate([
        `/sell-details-lot/${this.customerId}`
      ]);
    } else {
      this.router.navigate([
        // `/sell-details/customer/${this.customerId}/sell-details`
        `/sell-details-lot/${this.customerId}`
      ]);
    }
  }

  fetchStates(countryId: number, callbackFunction: any = null) {
    const params = new HttpParams().set('country_id', countryId.toString());
    this.userService.getStates(params).subscribe(
      (response: any) => {
        this.states = response.data;
        this.cities = [];

        this.sellCustomerForm.controls['state_id'].setValue('');
        this.sellCustomerForm.controls['city_id'].setValue('');

        if (callbackFunction) {
          callbackFunction();
        }
      },
      (error) => {
        this.notificationService.showError(
          'Failed to fetch states. Please try again.',
          'Error'
        );
      }
    );
  }

  onCountryChange() {
    const countryId = this.sellCustomerForm.controls['country_id'].value;
    if (countryId) {
      this.fetchStates(countryId);
      const selectedCountry = this.countries.find((c) => c.id === +countryId);
      if (selectedCountry) {
        this.sellCustomerForm.patchValue({
          currency_code: selectedCountry.currency,
        });
      }
    }
  }

  onStateChange() {
    const stateId = this.sellCustomerForm.controls['state_id'].value;
    if (stateId) {
      this.fetchCities(stateId);
    }
  }
  fetchCities(stateId: number) {
    const params = new HttpParams().set('state_id', stateId.toString());
    this.userService.getCities(params).subscribe(
      (response: any) => {
        this.cities = response.data;

        if (this.cities && this.cities.length > 0) {
          const selectedCity = this.cities.find(
            (city: any) => city.name === this.sellCustomerForm.controls['city_id'].value
          );
          if (selectedCity) {
            this.sellCustomerForm.controls['city_id'].setValue(selectedCity.id);
          } else {
            this.sellCustomerForm.controls['city_id'].setValue(this.cities[0].id);
          }
        }
      },
      (error) => {
        console.error('Error fetching cities:', error);
        this.notificationService.showError(
          'Failed to fetch cities. Please try again.',
          'Error'
        );
      }
    );
  }

  sendOtp() {
    const mobile = this.sellCustomerForm.get('mobilenumber')?.value?.trim();

    if (!mobile) {
      this.notificationService.showError('Please enter mobile number first!', 'Validation Error');
      return;
    }

    if (!/^\d{10}$/.test(mobile)) {
      this.notificationService.showError('Please enter a valid 10-digit mobile number!', 'Validation Error');
      return;
    }

    this.userService.sendOtp(mobile).subscribe({
      next: (res) => {
        if (res.success) {
          this.notificationService.showSuccess(`✅ OTP sent successfully to ${mobile}`, 'Success');
          this.isOtpSent = true;
        } else {
          this.notificationService.showError('❌ Failed to send OTP!', 'validation erro');
        }
      },
      error: () => {
        this.notificationService.showError('❌ Error while sending OTP!', 'Validation Error');
      }
    });
  }

  verifyOtp() {
    const enteredOtp = this.sellCustomerForm.get('otp')?.value?.trim();

    if (!enteredOtp) {
      this.notificationService.showError('Please enter the OTP!', 'Success');
      return;
    }

    this.userService.verifyOtp(enteredOtp).subscribe({
      next: (res) => {
        if (res.success) {
          this.notificationService.showSuccess('✅ OTP Verified Successfully!', 'Success');
        } else {
          this.notificationService.showError(`❌ ${res.message}`, 'Validation error');
        }
      },
      error: () => {
        this.notificationService.showError('❌ Error verifying OTP!', 'Validation Error ');
      }
    });
  }



  // verifyOtp() {
  //   const enteredOtp = this.sellCustomerForm.get('otp')?.value?.trim();

  //   if (!enteredOtp) {
  //     this.message = 'Please enter the OTP!';
  //     return;
  //   }

  //   this.userService.verifyOtp(enteredOtp).subscribe({
  //     next: (res) => {
  //       if (res.success) {
  //         this.message = '✅ OTP Verified Successfully!';
  //       } else {
  //         this.message = `❌ ${res.message}`;
  //       }
  //     },
  //     error: () => {
  //       this.message = '❌ Error verifying OTP!';
  //     }
  //   });
  // }

  loadFirmList() {
    this.firmService.getFirms().subscribe((res: any) => {
      this.firmTypes = res.data;
    });
  }

  focusNext(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key === 'Enter') {
      keyboardEvent.preventDefault();
      const target = keyboardEvent.target as HTMLElement;
      const form = target.closest('form');
      if (!form) return;
      const focusable = Array.from(
        form.querySelectorAll<HTMLElement>('input, select, textarea, button')
      ).filter(el => !el.hasAttribute('disabled') && el.tabIndex !== -1);
      const index = focusable.indexOf(target);
      if (index > -1 && index + 1 < focusable.length) {
        focusable[index + 1].focus();
      }
    }
  }
  onMobileInput(event: Event) {
    const input = event.target as HTMLInputElement;

    // ✅ Allow only numbers
    input.value = input.value.replace(/[^0-9]/g, '');

    // ✅ Detect selected country
    const selectedCountry = this.itiInstance?.getSelectedCountryData()?.iso2;

    // ✅ If India → Force ONLY 10 digits
    if (selectedCountry === 'in') {
      if (input.value.length > 10) {
        input.value = input.value.slice(0, 10);
      }
    }

    // ✅ Sync with form control
    this.sellCustomerForm.get('mobilenumber')?.setValue(input.value, {
      emitEvent: false,
    });

    // ✅ Keep your existing filtering
    this.filterCustomersByMobile(event);
  }


  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) return;

    setTimeout(() => {
      if (!this.phoneInput?.nativeElement) return;

      this.itiInstance = intlTelInput(this.phoneInput.nativeElement, {
        initialCountry: 'in',
        separateDialCode: true,
        preferredCountries: ['in', 'us', 'ae', 'gb'],
      } as any);

    }, 0);
  }
}
